'use client'

import React, { useEffect } from 'react'
import { usePostHog } from 'posthog-js/react'
import { AnalyticsContext } from '@/context/analyticsContext'

type AnalyticsProviderProps = {
    children: React.ReactNode
}

export const AnalyticsProvider: React.FC<AnalyticsProviderProps> = ({
    children,
}) => {
    const posthog = usePostHog()
    const analytics = React.useContext(AnalyticsContext).analytics

    useEffect(() => {
        if (posthog) {
            analytics.initialize(posthog)
        }
    }, [posthog])

    return (
        <AnalyticsContext.Provider value={{ analytics }}>
            {children}
        </AnalyticsContext.Provider>
    )
}
